import { useSelector } from 'react-redux';

export default (routerName) => {
  const userRoles =
    useSelector((state) => state.auth?.userIntrospect?.resources) ?? null;

  return (
    userRoles[routerName] ?? {
      isViewEnabled: false,
      isCrudEnabled: false,
      isDrawingEnabled: false,
      isApprovalEnabled: false,
      changeCourier: false,
      changeStatus: false,
      edit: false,
      orderTransfer: false
    }
  );
};
